import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { DetailResponse } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 获取账户说明页详情
export function getAccountDetail() {
  return request.get<DetailResponse>(`${baseUrl}/sofipo/v0/main/account/explanation`, {});
}
